import { render, staticRenderFns } from "./insertLiveDialog.vue?vue&type=template&id=5b7cb6d7&scoped=true&"
import script from "./insertLiveDialog.vue?vue&type=script&lang=js&"
export * from "./insertLiveDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertLiveDialog.vue?vue&type=style&index=0&id=5b7cb6d7&scoped=true&lang=css&"
import style1 from "./insertLiveDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7cb6d7",
  null
  
)

export default component.exports